export default "__VITE_ASSET__BHmflt7q__";